// extracted by mini-css-extract-plugin
export default {"teaserContainer":"CKqogH_godZbj4kjDvU7","teaserTitle":"xuASesqGMI5R2_zCEfoY","teaserMeta":"ycBoSmkigsaplxNY9Zu3"};